export default __webpack_public_path__ + "static/media/radiobox-marked.f638075e.svg";